import React from "react";
import { ProgressBar } from "primereact/progressbar";

export default function ProgressBarElement(props) {
  return (
    <div className={props.style}>
      <ProgressBar value={props.value}></ProgressBar>
    </div>
  );
}
